const TRUTHY = ['1', 'true', 'on', 'yes'];

export const maintenanceEnabled = TRUTHY.indexOf(
	String(process.env.VUE_APP_MAINTENANCE || '').trim().toLowerCase()
) !== -1;

export default maintenanceEnabled;
